const flu_config_store = {
    subscribers:{},
    stations: [],
    data:{
        filter_options:{
            only_with_extravasation: true,
            legends:{
                ok: true, attention: true, alert:true, emergency:true, extravasation:true
            },
            plu_legends: {
                low:true, moderate:true, high: true, 'very-high':true
            },
            ugrhi_cods: [],
            city_ibges: []
        }
    },
    getStations(){
        return this.stations
    },
    getStation(id){
        return this.stations.find(x=>x.station_prefix_id === id)
    },
    setFilterLegendsOption(field, value){
        this.data.filter_options.legends[field] = value
        this.publish('UPDATE_FILTER_OPTIONS', this.data.filter_options)
    },
    setFilterPluLegendsOption(field, value){
        this.data.filter_options.plu_legends[field] = value
        this.publish('UPDATE_FILTER_OPTIONS', this.data.filter_options)
    },
    setFilterOptions(option, values){
        this.data.filter_options[option] = values
        this.publish('UPDATE_FILTER_OPTIONS', this.data.filter_options)
    },
    getFilterOption(field){
        return this.data.filter_options[field]
    },
    getFilterLegendsOption(){
        return this.data.filter_options.legends
    },
    setStations(stations){
        this.stations = stations
        this.publish('SET_STATIONS', stations)
    },
    setStationProp(station_id, prop, value){
        let station = this.stations.filter(x=>x.id === station_id)[0]
        if(station){
            station[prop] = value
            this.publish('SET_STATION_PROP', station)
        }
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default flu_config_store